module.exports = __webpack_public_path__ + "static/img/404.f3b12b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/404.png
// module id = bhgG
// module chunks = 1